import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import styled from "@emotion/styled";
import { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Typography from "@mui/material/Typography";
import { usePlayerAvailabilityList } from "./usePlayerAvailabilityList";
import { CardContent } from "@mui/material";
import { Card } from "@mui/material";

export interface SingleTournamentPlayerItem {
  playerId: number;
  isVisitingPlayer: boolean;
  PlayerName: string;
  PlayerRating: number;
  isSplitSpot: boolean;
}
export default function IndividualPlayerCard({
    devPort,
    clubId,
    league_id,
    managerMode,
    refreshProps
}: {
  devPort: string;
  clubId: number;
  league_id: number;
  managerMode: number;
  refreshProps: number;
}) {
  const [singlePlayerSignups, setSinglePlayerSignups] = useState<SingleTournamentPlayerItem[]>([]);
  const { unavailablePlayers } = usePlayerAvailabilityList({
    devPort,
    clubId,
    selectedLeague: league_id,
    refreshProps
  });
  const loadSinglePlayerSignupList = useCallback(() => {
    const fetchPlayers =
      devPort +
      "tournament_single_signups/" +
      clubId +
      "/" +
      league_id;
    fetch(fetchPlayers)
      .then((response) => response.json())
      .then((data) => {
        console.log("Single Player Signups");
        console.log(data);
        if (data.length > 0) {
          const newSinglePlayerSignups: SingleTournamentPlayerItem[] = [];
          data.forEach((player: any) => {
            if (managerMode === -1 || managerMode === player[0]) {
              newSinglePlayerSignups.push({
                playerId: player[0],
                PlayerName: player[1] + " " + player[2],
                PlayerRating: player[3],
                isSplitSpot: player[4],
                isVisitingPlayer: player[5],
              });
            }
          });
          setSinglePlayerSignups(newSinglePlayerSignups);
        }
      });
  }, [devPort, clubId, league_id, managerMode]);

  useEffect(() => {
    loadSinglePlayerSignupList();
  }, [loadSinglePlayerSignupList, refreshProps]);
  function createData(name: string, rating: number, splitSpot: boolean, playerId: number) {
    return { name, rating, splitSpot, playerId };
  }
  const [rows, setRows] = useState<
    { name: string; rating: number; splitSpot: boolean; playerId: number }[]
  >([]);
  useEffect(() => {
    let newRows: {
      name: string;
      rating: number;
      splitSpot: boolean;
      playerId: number;
    }[] = [];
    console.log(singlePlayerSignups);
    singlePlayerSignups.map((player: SingleTournamentPlayerItem) =>
      newRows.push(
        createData(player.PlayerName, player.PlayerRating, player.isSplitSpot, player.playerId)
      )
    );
    setRows(newRows);
  }, [singlePlayerSignups]);
  const StyledTableRow = styled(TableRow)<{ index: number }>(({ index }) => ({
    backgroundColor: index % 2 === 0 ? "#f5f5f5" : "transparent",
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  if (rows.length === 0) {
    return null;
  }
  return (
    <Card>
      <CardContent>
      <Typography variant="h6">Individual Player Signups</Typography>
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
          <TableRow>
            <TableCell component="th" scope="row">Player Name</TableCell>
            <TableCell align="right">Rating</TableCell>
            <TableCell align="right">Split Spot</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => {
            if(unavailablePlayers.includes(row.playerId)) {
              return null;
            }
            return (
              <StyledTableRow key={index} index={index}>
                <TableCell component="th" scope="row">
                  <Box sx={{ position: "relative", display: "inline-block" }}>
                    {row.name}
                  </Box>
                </TableCell>
                <TableCell align="right">{row.rating}</TableCell>
                <TableCell align="right">
                  {row.splitSpot ? <CheckCircleIcon color="success" /> : "-"}
                </TableCell>
              </StyledTableRow>
            );
          })}
          </TableBody>
        </Table>
      </TableContainer>
      </CardContent>
    </Card>
  );
}
